// extracted by mini-css-extract-plugin
export default {"active":"Tab_active__B2QyS","inactive":"Tab_inactive__wedEh"};